"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_TYPE_ERROR = exports.TEXT_TYPE_SUBTITLE_SIZE_10 = exports.TEXT_TYPE_SUBTITLE_SIZE_12 = exports.TEXT_TYPE_SUBTITLE = exports.TEXT_TYPE_TITLE_SIZE_18 = exports.TEXT_TYPE_TITLE = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const colors_1 = __importDefault(require("../../styles/colors"));
const textStyles_1 = __importDefault(require("./textStyles"));
exports.TEXT_TYPE_TITLE = 'title';
exports.TEXT_TYPE_TITLE_SIZE_18 = 'title18';
exports.TEXT_TYPE_SUBTITLE = 'subtitle';
exports.TEXT_TYPE_SUBTITLE_SIZE_12 = 'subtitle12';
exports.TEXT_TYPE_SUBTITLE_SIZE_10 = 'subtitle10';
exports.TEXT_TYPE_ERROR = 'error';
const Text = ({ titleType, children, color = titleType === exports.TEXT_TYPE_ERROR ? colors_1.default.COLOR_BRICK_RED_5 : colors_1.default.COLOR_BLACK, subtitleExtraText, biggerSubtitle = false, onPress, style, }) => (react_1.default.createElement(react_native_1.View, null,
    react_1.default.createElement(react_native_paper_1.Text, { onPress: onPress, style: [
            textStyles_1.default.font,
            titleType === exports.TEXT_TYPE_TITLE && textStyles_1.default.titleText,
            titleType === exports.TEXT_TYPE_TITLE_SIZE_18 && textStyles_1.default.smallerTitleText,
            titleType === exports.TEXT_TYPE_SUBTITLE && (biggerSubtitle ? textStyles_1.default.biggerSubtitleText : textStyles_1.default.subtitleText),
            titleType === exports.TEXT_TYPE_SUBTITLE_SIZE_12 && textStyles_1.default.smallerSubtitleText,
            titleType === exports.TEXT_TYPE_SUBTITLE_SIZE_10 && textStyles_1.default.smallestSubtitleText,
            titleType === exports.TEXT_TYPE_ERROR && textStyles_1.default.errorLabel,
            { color },
            style,
        ] }, children),
    subtitleExtraText && (react_1.default.createElement(react_native_paper_1.Text, { style: [textStyles_1.default.subtitleText, { color }] }, subtitleExtraText))));
Text.defaultProps = {
    color: colors_1.default.COLOR_BLACK,
    subtitleExtraText: undefined,
    biggerSubtitle: false,
    onPress: undefined,
    style: undefined,
};
exports.default = Text;
